import { Component, HostListener } from '@angular/core';
import { NgGrid } from '../../angular2-grid/directives/NgGrid';
import { NgGridConfig, NgGridItemConfig } from '../../angular2-grid/interfaces/INgGrid';
import {
    WidgetPlaceholder, DashboardConfigManager, NotificationService, DashboardLayout, WidgetConfig, ParameterService, AuthService,
    LogService, GlobalErrorHandler, CommonService
} from 'core-dashboard';
import { Subscription } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { forkJoin, throwError } from 'rxjs';
import { ComponentResolver } from '../ComponentResolverService';
//import 'rxjs/add/operator/map';
//import { of as observableOf } from "rxjs";
//import 'rxjs/add/operator/catch';
import { catchError, map } from 'rxjs/operators';
import { PieChart, TrendSeriesChart,HorizontalGroupedBarChart, TrendSeriesMultiAxisChart, VerticalBarChart, HorizontalBarChart, RadialGaugeChart, VerticalGroupedBarChart } from 'dashboard-widgets';
import { DesigoccEventCountersProvider,DesigoccObjectValueCloudProvider, EMLPWSIObjectValueProvider,EMLPObjectValueProvider,GroupedBarchartProvider, WSIObjectValueProvider, DesigoCCTrendSeriesProvider, PmBarchartProvider, PmIntervalBasedBarchartProvider, PmBreakerHealthBarchartProvider, PmComparableBarchartProvider } from 'dashboard-providers';

@Component({
    selector: 'Dashboard',
    templateUrl: './home.component.template.html',
    providers: [{
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
    }]
})
export class HomeComponent {
    subscription: Subscription;
    widgets: Array<WidgetPlaceholder> = [];
    widgetConfigs: WidgetConfig[];
    Maingrid: NgGrid;
    isTranslationLoaded: boolean = false;
    timeOutId = 0;
    isAllowed: boolean = true;
    isCtrlPressed: boolean = false;
    zoomRation_IE10: number = 1;
    styleUri: string = "configs/styles/";
    configFileName: string;
    defaultStyles = "DefaultStyle.json";
    style: any[] = [];
    styleFiles: any[] = [];
    BackgroundColor: string = "Black";
    GridConfig: NgGridConfig = {
        draggable: false,
        limit_to_screen: true,
        auto_resize: true,
        margins: [2, 2, 2, 2]
    }


    constructor(private http: HttpClient, private configService: DashboardConfigManager, private logger: LogService,
        private parameters: ParameterService, private notificationService: NotificationService, private _authService: AuthService, private translateService: TranslateService
        , private commonService: CommonService) {
    }


    @HostListener('window:keydown', ['$event'])
    handleKeyDownEvent(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x == 17 && !this.isCtrlPressed) {
            this.isCtrlPressed = true;
            this.GridConfig.limit_to_screen = false;
            this.GridConfig.auto_resize = false;
        }
    }

    @HostListener('window:keyup', ['$event'])
    handleKeyUpEvent(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x == 17 && this.isCtrlPressed) {
            this.isCtrlPressed = false;
            this.ResetGridZoom();
        }
    }

    ngOnInit() {
        try {
            this.configService.readConfig().then(() => {
                this.configService.replaceQueryParams(undefined, undefined);
                if (this.logger)
                    this.logger.CreateLogger();
                //Set Default Language

                let paramCulture = this.parameters.getParameter("locale");
                this.configFileName = this.parameters.getParameter("configfile");
                //updated code as culture was not working as expected. it was working only with en_US and not with other languages
                if (paramCulture) {
                    this.translateService.setDefaultLang(paramCulture);
                    this.translateService.currentLang = paramCulture;
                }
                else {
                    this.translateService.setDefaultLang("en-US")//("en-US");
                    this.translateService.currentLang = "en-US";
                }

                this.translateService.use(this.translateService.currentLang).subscribe(() => {
                    this.isTranslationLoaded = true;
                    this.Start();
                });

                setTimeout(() => {
                    this.OnLoaded();
                }, 1000);
            });
        }
        catch (error) {
            if (this.logger != null && typeof this.logger != "undefined")
                this.logger.logError(HomeComponent.name, error);
        }
    }

    OnLoaded() {
        if (!this.isTranslationLoaded) {
            if (this.logger != null && typeof this.logger != "undefined")
                this.logger.logError("Dashboard", "Unable to load localization resource for language code :" + this.translateService.currentLang);
            this.Start();
        }
    }

    private Start() {
        if (this._authService.HasValidSSO() && this._authService.HasValidToken() === false) {
            this._authService.LoginWithSSO().subscribe(
                response => {
                    if (response) {
                        this.commonService.getSystemData();
                        this.CreateGrid();
                    }
                }, (error: any) => {
                    if (this.logger != null && typeof this.logger != "undefined")
                        this.logger.logError("Dashboard", "Unable to login into WSI : " + error);
                    this.CreateGrid();
                });
        } else {
            this.CreateGrid();
        }
    }

    CreateGrid() {
        try {
            let layout = this.configService.getDashboardLayout();
            if (layout) {
                this.setDashboardGrid(layout);
                this.widgetConfigs = this.configService.getWidgets();
                this.generateGrid();
                this.zoomRation_IE10 = Math.round(window.devicePixelRatio * 100);
                this.logger.logInfo("Dashboard", "zoomratio is:" + (this.zoomRation_IE10 ? (this.zoomRation_IE10).toString() : " not available."));
            }
        }
        catch (e) {
            this.logger.logError("Dashboard", e);
        }
    }

    private ResetGridZoom() {
        try {
            if (window.devicePixelRatio) {
                this.logger.logInfo("Dashboard", "Current zoom level is:" + (window.devicePixelRatio ? (window.devicePixelRatio * 100).toString() + "%" : " not available."));
                if (window.devicePixelRatio === 1) {
                    this.GridConfig.limit_to_screen = true;
                    this.GridConfig.auto_resize = true;
                }
            }
            else {
                //Fallback case for IE10 and below
                if (Math.round(window.devicePixelRatio * 100) !== 0)
                    this.logger.logInfo("Dashboard", "Current zoom level is:" + ((Math.round(window.devicePixelRatio * 100) / this.zoomRation_IE10) * 100).toString() + "%");

                if (Math.round(window.devicePixelRatio * 100) === this.zoomRation_IE10) {
                    this.GridConfig.limit_to_screen = true;
                    this.GridConfig.auto_resize = true;
                }
            }
        }
        catch (e) {
            this.logger.logError("Dashboard", e);
        }
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {

    }

    OnGridInit(grid: NgGrid) {
        this.Maingrid = grid;
    }


    OnResize(widgetPlaceholder: WidgetPlaceholder) {
        if (!this.isCtrlPressed && this.notificationService && this.isAllowed) {
            this.ResetGridZoom();
            this.isAllowed = false;
            this.logger.logInfo("Dashboard", "Resize event called! resizing grid controls.")
            this.notificationService.announceChange("OnResize");
            setTimeout(() => {
                this.isAllowed = true;
            }, 500);
        }
    }

    private setDashboardGrid(config: DashboardLayout) {
        this.GridConfig.visible_cols = config.cols;
        this.GridConfig.visible_rows = config.rows;
        this.GridConfig.margins = [config.Margins.top, config.Margins.right, config.Margins.bottom, config.Margins.left];
        this.BackgroundColor = config.backgroundColor;
    }

    private generateGrid() {
        this.widgets = [];
        this.widgetConfigs.forEach(element => {
            var index = this.styleFiles.indexOf(element.style);
            if (index < 0)
                this.styleFiles.push(element.style)
        });
        this.readStyles().then(() => {
            try {
                for (let i = 0; i < this.widgetConfigs.length; i++) {
                    let widgetConfig = this.widgetConfigs[i];

                    if (widgetConfig.layout.startColumn > this.GridConfig.visible_cols
                        || widgetConfig.layout.startRow > this.GridConfig.visible_rows
                        || widgetConfig.layout.columnSpan > this.GridConfig.visible_cols
                        || widgetConfig.layout.rowspan > this.GridConfig.visible_rows) {
                        //Layout config for widget placement is incorrect, skip adding the widget.
                        this.logger.logInfo("Dashboard", "Layout config (Row,Column,Row Span or Column Span) for " + widgetConfig.name + "widget placement is does not fall within the dashboard grid range.")
                    }
                    else //Layout Config is fine, proceed
                    {
                        //getting the instance of component and provider from dynamic modules
                        ///// let allComponents: Array<any> = ComponentResolver.getModule();
                        // alert("Com"+allComponents);

                        let component = undefined;
                        let provider = undefined;
                        if (widgetConfig.chartType == "PieChart") {
                            component = PieChart;
                            provider = DesigoccEventCountersProvider;
                        }

                        if (widgetConfig.chartType == "RadialGaugeChart") {
                            component = RadialGaugeChart;
                            provider = WSIObjectValueProvider;

                        }
                        if (widgetConfig.chartType == "TrendSeriesChart") {
                            component = TrendSeriesChart;
                            provider = DesigoCCTrendSeriesProvider;

                        }
                        if (widgetConfig.chartType == "VerticalBarChart") {
                            component = VerticalBarChart;
                            provider = DesigoccEventCountersProvider;

                        }
                        if (widgetConfig.chartType == "HorizontalBarChart") {
                            component = HorizontalBarChart;
                            provider = DesigoccEventCountersProvider;

                        }
                        if (widgetConfig.chartType == "HorizontalGroupedBarChart") {
                            component = HorizontalGroupedBarChart;
                            
                        }
                        if (widgetConfig.chartType == "TrendSeriesMultiAxisChart") {
                            component = TrendSeriesMultiAxisChart;
                            provider = DesigoCCTrendSeriesProvider;
                        }
                        if (widgetConfig.chartType == "VerticalGroupedBarChart") {
                            component = VerticalGroupedBarChart;
                        }
                        if (widgetConfig.dataProvider.name == "EMLPObjectValueProvider") {
                            provider = EMLPObjectValueProvider;
                        }
                        if (widgetConfig.dataProvider.name == "EMLPWSIObjectValueProvider") {
                            provider = EMLPWSIObjectValueProvider;
                        }
                        if (widgetConfig.dataProvider.name == "PmBarchartProvider") {
                            provider = PmBarchartProvider;
                        }
                        if (widgetConfig.dataProvider.name == "PmBreakerHealthBarchartProvider") {
                            provider = PmBreakerHealthBarchartProvider;
                        }
                        if (widgetConfig.dataProvider.name == "PmComparableBarchartProvider") {
                            provider = PmComparableBarchartProvider;
                        }
                        if (widgetConfig.dataProvider.name == "PmIntervalBasedBarchartProvider") {
                            provider = PmIntervalBasedBarchartProvider;
                        }
                        if (widgetConfig.dataProvider.name == "GroupedBarchartProvider") {
                            provider = GroupedBarchartProvider;
                        }
                        if (widgetConfig.dataProvider.name == "DesigoccObjectValueCloudProvider") {
                            provider = DesigoccObjectValueCloudProvider;
                        }
                        // let provider = [widgetConfig.dataProvider.name];

                        let conf: NgGridItemConfig = {
                            col: widgetConfig.layout.startColumn as number,
                            row: widgetConfig.layout.startRow as number,
                            sizex: widgetConfig.layout.columnSpan as number,
                            sizey: widgetConfig.layout.rowspan as number,
                            payload: i,
                            resizable: false
                        }

                        this.widgets[i] = {
                            id: i,
                            config: conf,
                            componentdata: {
                                id: i,
                                name: widgetConfig.name,
                                component: component,
                                inputs: {
                                    dataProvider: widgetConfig.dataProvider,
                                    dataProviderInstance: provider,
                                    style: this.style[widgetConfig.style],
                                    dashoboardMargins: this.GridConfig.margins,
                                    config: widgetConfig.config
                                }
                            }
                        };

                    }
                }
            } catch (error) {
                this.logger.logError("Dashboard", error);
            }
        });
    }

    //to get style file url
    private getStyleFileURI(file): string {
        let uri = this.styleUri;
        let fileName = file != undefined && typeof (file) == "string" && file.indexOf('.json') >= 0 ? file : this.defaultStyles;
        uri += fileName;
        return uri;
    }

    //to read styles from specified style file (style substitution)
    private readStyles(): Promise<void> {
        try {
            let service = this;
            let forkJoins: Observable<any>[] = [];
            service.styleFiles.push(service.defaultStyles);
            let defaultFileIndex = service.styleFiles.length - 1;
            let promise: Promise<void> = new Promise<void>(function (resolve) {
                for (let i = 0; i < service.styleFiles.length; i++) {
                    let uri = service.getStyleFileURI(service.styleFiles[i]);
                    forkJoins.push(service.http.get(uri)
                        .pipe(map(data => data)
                            , catchError(error => of(error)))
                    );
                }
                forkJoin(forkJoins).subscribe(result => {
                    for (let i = 0; i < service.styleFiles.length; i++) {
                        if (result[i].status && result[i].status === 404) {
                            service.logger.logError("File Not Found", service.styleFiles[i]);
                            service.style[service.styleFiles[i]] = result[defaultFileIndex].status && result[defaultFileIndex].status === 404 ? {} : result[defaultFileIndex];
                        } else {
                            service.style[service.styleFiles[i]] = result[i] != "" ? result[i] : {};
                        }
                    }
                    resolve();
                })
            });
            return promise;
        }
        catch (error) {
            this.logger.logError("Dashboard", error);
        }
    }

    private handleError(error: any): Observable<any> {
        let errMsg: any = error.message || "Server error";
        this.logger.logError("Dashboard", errMsg); // log to console instead
        return throwError(errMsg);
    }
}
